import { MerchantSearchConstants } from 'constants/merchantSearch';
import { createAction } from 'redux-actions';

export const merchantSearch = createAction(MerchantSearchConstants.GET_MERCHANTS);
